import React from 'react'
import { Icon, Paragraph, Stack } from '@ui'
import { env } from 'utils'

import { useUSDTotalSpaceTips } from './useUSDTotalSpaceTips'

export function SpaceTotalTips(props: { spaceId: string }) {
    const { spaceId } = props
    const { usdTotal } = useUSDTotalSpaceTips({ spaceId })

    if (!env.VITE_TIPS_ENABLED) {
        return null
    }
    return (
        <Stack horizontal centerContent gap="xs">
            <Icon type="dollarFilled" color="cta1" size="square_md" padding="xxs" />
            <Paragraph>{usdTotal || '0'} Tips</Paragraph>
        </Stack>
    )
}
